package org.gstechnovos.jexonplastech.styles

import com.varabyte.kobweb.silk.style.CssStyle

val AchievementStyle = CssStyle {

}